import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, PropType, ref, watch } from "vue";
import ChecklistFieldModule from "@/components/views/productView/ChecklistFieldModule.vue";
import { ChecklistSegment } from "@/interfaces/components/configurator/ChecklistSegment";
import { ProductForm } from "@/interfaces/components/configurator/ProductForm";
import { ProductDetails } from "@/interfaces/components/configurator/ProductDetails";
import { ActiveProductFormValueObject } from "@/interfaces/general/ActiveProductFormValueObject";
import Offer from "@/models/Offer";
import { filterProductsFromOfferItems as filterProductsFromOfferItemsHelper } from "@/helpers/OfferItemTableHelper";
import OfferItem from "@/models/OfferItem";
import OfferTitle from "@/models/OfferTitle";
import { TransformedTableOfferItem } from "@/interfaces/components/ProductsInOffer/TransformedTableOfferItem";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistSegmentModule',
  props: {
  productFormValues: {
    type: Object as PropType<ActiveProductFormValueObject | null>,
    default: null,
  },
  checklistSegment: {
    type: Object as PropType<ChecklistSegment>,
    required: true,
  },
  activeProductFormId: {
    type: Number as PropType<number | null>,
    default: null,
  },
  pIdFieldErrors: { type: Array as PropType<string[]>, default: [] },
  levelOverride: { type: Number, default: 0 },
  offer: { type: Object as PropType<Offer | null>, default: null },
  offerItem: { type: Object as PropType<OfferItem | null>, default: null },
  currentProductForm: {
    type: Object as PropType<ProductForm | null>,
    default: null,
  },
  isConfigurator: { type: Boolean, default: false },
  noSegments: { type: Boolean, default: false },
  temporaryDisabledPIDs: { type: Array as PropType<string[]>, default: [] },
  productDetails: {
    type: Object as PropType<ProductDetails | null>,
    default: null,
  },
},
  emits: ["is-connected", "is-production"],
  setup(__props, { emit }: { emit: ({
  (e: "is-connected", value: number | null): void;
  (e: "is-production", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const connection = ref<number | null>(null);
const level = ref(0);
const production = ref(true);
const vodilaSegmentId = "9483";

watch(
  () => props.levelOverride,
  (newValue: number) => {
    level.value = newValue;
  },
  { immediate: true }
);

const filteredChecklistFields = computed(() => {
  return props.checklistSegment.checklistFields.filter((checklistField) => {
    return (
      checklistField.fieldType !== "abort" &&
      checklistField.fieldType !== "warning"
    );
  });
});

function checklistFieldHasVisibilityFunction(checklistField: any) {
  return checklistField.checklistVisibleFunction != null;
}

function filterProductsFromOfferItems(
  offerItems: Array<OfferItem | OfferTitle | TransformedTableOfferItem>
) {
  return filterProductsFromOfferItemsHelper(offerItems, false);
}

function switchLevel(newLevel: number) {
  level.value = newLevel;
}

function resetLevel() {
  if (
    (props.isConfigurator &&
      router.currentRoute.query.productSystemName === "PENTO" &&
      props.checklistSegment.name === "Vodila") ||
    props.checklistSegment.id === vodilaSegmentId
  ) {
    level.value = 0;
  }
}

(() => {
  if (props.offerItem) {
    connection.value = props.offerItem.connection;
    production.value = props.offerItem.production;
  }
})();

onMounted(() => {
  resetLevel();
});

return { __sfc: true,props, emit, connection, level, production, vodilaSegmentId, filteredChecklistFields, checklistFieldHasVisibilityFunction, filterProductsFromOfferItems, switchLevel, resetLevel, ChecklistFieldModule }
}

})